<template>
  <h2
    class="px-1 text-sm font-medium uppercase leading-loose text-background-fg/70"
  >
    <slot />
  </h2>
</template>
